class TokenService {
  public getToken(): string | undefined | null {
    return sessionStorage.getItem('@auth');
  }

  public setToken(token: string) {
    return sessionStorage.setItem('@auth', token);
  }

  public clearToken() {
    sessionStorage.removeItem('@auth');
  }

  public decode<T>(token: string): T {
    try {
      const data = this.parseJwt(token);
      const currentTime = Date.now() / 1000;
      return currentTime > data.exp ? null : data;
    } catch (err) {
      return null as any;
    }
  }

  private parseJwt(token: string) {
    return JSON.parse(this.b64DecodeUnicode(token.split('.')[1].replace('-', '+').replace('_', '/')));
  }

  private b64DecodeUnicode = (str: string) =>
    decodeURIComponent(
      Array.prototype.map.call(atob(str), (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
    );
}

const tokenService = new TokenService();
export default tokenService;